export const FRONT_EVENTS = {
  GCLID: 'gclid',
  PAGEVIEW: 'pageview',
} as const;

export const ANONYMOUS_ID_HEADER_NAME = 'front-anonymous-id';
